import React from 'react';
import { motion } from 'motion/react';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from '../common/Card';
import {
  CalendarIcon,
  ListBulletIcon,
} from '@radix-ui/react-icons';

const DetailItem = ({ icon: Icon, label, value }) => (
  <div className="flex items-center space-x-4 py-2">
    <div className="flex h-8 w-8 items-center justify-center rounded-md bg-primary/10 dark:bg-primary/20">
      <Icon className="h-4 w-4 text-primary" />
    </div>
    <div className="space-y-1">
      <p className="text-sm text-muted-foreground">{label}</p>
      <p className="font-medium">{value}</p>
    </div>
  </div>
);

const ActivityDetailsCard = ({ activity }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Card>
        <CardHeader>
          <CardTitle>Activity Details</CardTitle>
        </CardHeader>
        <CardContent className="grid gap-6">
          <DetailItem
            icon={ListBulletIcon}
            label="Activity Name"
            value={activity.name}
          />
          <DetailItem
            icon={CalendarIcon}
            label="Started On"
            value={new Date(activity.created_at).toLocaleDateString('en-US', {
              weekday: 'long',
              day: 'numeric',
              month: 'long',
              year: 'numeric',
            })}
          />
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default ActivityDetailsCard; 